import {AppointmentBooked} from 'domain/usecases';
import {DateFormatEnum} from 'presentation/constants';
import {formatAddress, formatDateString} from 'presentation/utils';
import normalizeDate from 'presentation/utils/normalizeDate/normalizeDate';
import {formatUtcDate} from 'presentation/utils/convertDate';
import {validatePhoneNumbers} from '../validatePhoneNumbers';
import {ParsedTelehealthAppointment} from './types';

export const parseTelehealthAppointments = (
	agendamentosTeleconsulta: AppointmentBooked[],
): ParsedTelehealthAppointment[] =>
	agendamentosTeleconsulta.map(item => {
		const normalizedDate = normalizeDate(item.dtConsulta);
		const mustNotFormatUtc = !item.dtConsulta.includes('T');

		return {
			bookingNumber: item.nuConsulta?.toString(),
			specialtyCode: item.cdEspecialidade?.toString(),
			subSpecialtyCode: item.cdSubEspecialidade?.toString(),
			specialtyName: item.dsSubEspecialidade
				? `${item.dsEspecialidade} - ${item.dsSubEspecialidade}`
				: item.dsEspecialidade,
			clinicName: item.nmPrestadorJuridico,
			providerName: item.nmPrestadorFisico,
			bookingType: item.tipoConsulta,
			formattedAddress: formatAddress({
				type: item.tipoLogradouro,
				state: item.cdUf,
				city: item.nmCidade,
				number: item.numero?.toString(),
				address: item.logradouro,
				complement: item.complemento,
				district: item.bairro,
				reference: item.pontoReferencia,
			}),
			dateUtc: normalizedDate,
			date: formatDateString(
				formatUtcDate(normalizedDate, mustNotFormatUtc),
				DateFormatEnum.DATE_FORMAT_9,
				'dd/MM/yyyy HH:mm',
			),
			dateOnly: formatDateString(
				formatUtcDate(normalizedDate, mustNotFormatUtc),
				DateFormatEnum.DATE_FORMAT_9,
				DateFormatEnum.DATE_FORMAT_8,
			),
			hour: formatDateString(
				formatUtcDate(normalizedDate, mustNotFormatUtc),
				DateFormatEnum.DATE_FORMAT_9,
				'HH:mm',
			),
			formattedDateWithWeekday: formatDateString(
				formatUtcDate(normalizedDate, mustNotFormatUtc),
				DateFormatEnum.DATE_FORMAT_9,
				'EEEE, dd/MM/yy',
			),
			telehealthUrl: item.urlconsulta,
			protocolNumber: item.nuProtocolo,
			isConfirmed: item.confirmado === 'Sim',
			phoneNumbers: validatePhoneNumbers(item.nuTelefone),
			flExecutaSessao: item.flExecutaSessao,
			email: item.email,
			phone: item.telefone,
			isFavorite: item.flPrestadorFavorito === 'S',
			cdPrestador: item.cdPrestadorFisico,
			telemedicina: item.telemedicina,
			acceptsAttachment: item?.aceitaAnexo,
		};
	});
